import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector, propTypes } from 'redux-form'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import PropTypes from 'prop-types'
import styles from './registrationPasswordForm.scss'
import FloatLabelInput from '../components/floatLabelInput/floatLabelInputComponent'
import FloatLabelPassword from '../components/floatLabelPassword/floatLabelPasswordComponent'
import CustomCheckmark from '../components/customCheckmark/customCheckmarkComponent'
import TogglePassword from '../components/togglePassword/togglePasswordComponent'
import SmartPrivacyLink from '../../containers/privacyLink/privacyLinkContainer'
import SmartTOSLink from '../../containers/tosLink/tosLinkContainer'
import { registerPasswordValidator } from 'tmw-validation'
import Recaptcha from 'react-recaptcha'

export function RegistrationPasswordForm (props) {
  const { t, handleSubmit } = props

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className={styles.formRow}>
        <Field
          name='password'
          component={FloatLabelInput}
          wrapperStyle={styles.password}
          placeholder={t('form:passwordPlaceholder')}
          type={props.showPasswordValue ? 'input' : 'password'}
          label={t('form:password')}
        />

        <Field
          wrapperStyle={styles.hiddenPassword}
          component={TogglePassword}
          name='showPassword'
          type='checkbox'
          id='showPassword'
        />
      </div>
      <div className={styles.formRow}>
        <Field
          name='passwordConfirm'
          component={FloatLabelInput}
          wrapperStyle={styles.password}
          placeholder={t('form:confirmPasswordPlaceholder')}
          type={props.showPasswordValue ? 'input' : 'password'}
          label={t('form:confirmPassword')}
        />

        <Field
          wrapperStyle={styles.hiddenPassword}
          component={TogglePassword}
          name='showPassword'
          type='checkbox'
          id='showPassword'
        />
      </div>
      <ul className={styles.legalList}>
        <li>
          <small>
            <SmartPrivacyLink />
          </small>
        </li>
        <li>
          <small>
            <SmartTOSLink />
          </small>
        </li>
      </ul>
      <Field
        wrapperStyle={styles.formGroup}
        name='acceptTos'
        component={CustomCheckmark}
        type='checkbox'
        label={t('form:acceptTos')}
        id='acceptTos'
      />

      <Recaptcha
        sitekey={
          process.env.NODE_ENV === 'development'
            ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
            : '6LfwSTshAAAAAJjxJ60l_69wfAixMrCzi5DLC_Et' // This doesn't have to be secret, works in staging and production
        }
        verifyCallback={response => props.change('captchaResponse', response)}
        expiredCallback={() => props.change('captchaResponse', null)}
      />

      <button
        type='submit'
        className={styles.bigButton}
        disabled={!props.captchaResponse}
      >
        {t('form:createAccount')}
      </button>
    </form>
  )
}

RegistrationPasswordForm.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  showPasswordValue: PropTypes.bool,
  captchaResponse: PropTypes.any,
  change: PropTypes.func
}

const selector = formValueSelector('registration')

export default compose(
  pure,
  translate(),
  reduxForm({
    validate: registerPasswordValidator,
    form: 'registration',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  }),
  connect(state => {
    const showPasswordValue = selector(state, 'showPassword')
    const captchaResponse = selector(state, 'captchaResponse')
    return {
      showPasswordValue,
      captchaResponse
    }
  })
)(RegistrationPasswordForm)



// WEBPACK FOOTER //
// ./src/forms/registrationPassword/registrationPasswordForm.js